import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import CustomModal from "../Modal";
import { useToggleState } from "../../../Hooks/useToggleState";
import { BASE_URL_IMAGE } from "../../../Api/client";
import { BsEyeFill, BsFileEarmarkArrowDown } from "react-icons/bs";
import toast from "react-hot-toast";

const CustomFileUpload = ({
   id,
   name,
   label,
   value,
   onChange,
   disabled,
   errors,
   message,
   multiple,
   require,
   accept,
}) => {
   const [isImageModalVisible, handleShowImageModal, handleCloseImageModal] =
      useToggleState();
   const [isIframeLoading, setIsIframeLoading] = useState(true);
   const [iframeKey, setIframeKey] = useState(0);

   const handleFileChange = (e) => {
      const uploadedFile = e.target.files[0];

      if (uploadedFile) {
         const allowedExtensions = ["png", "jpg", "jpeg", "csv", "txt", "pdf"];
         const fileExtension = uploadedFile.name.split(".").pop().toLowerCase();

         if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Only PNG, JPG, JPEG, CSV, TXT, and PDF files are allowed.");
            e.target.value = "";
            return;
         }

         if (uploadedFile.size > 10 * 1024 * 1024) {
            toast.error("File size should not exceed 10 MB.");
            e.target.value = "";
            return;
         }
      }

      if (onChange) {
         onChange(e, uploadedFile);
      }
   };

   function getDocumentURL(document) {
      let url = "";
      if (document && typeof document === "object") {
         url = URL.createObjectURL(document);
      } else {
         url = `${BASE_URL_IMAGE}${value}`;
      }
      return url;
   }

   const handleCloseModal = () => {
      handleCloseImageModal();
   };

   const fallbackDownload = () => {
      const filePath = value; // uploads/...
      const link = document.createElement("a");

      //console.log("filePath", filePath);
      link.href = `https://api.oillogistics.co.in/${filePath}`;
      link.download = "";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
   };

   return (
      <div class="form-group w-100">
         <CustomModal
            showModal={isImageModalVisible}
            handleCloseModal={handleCloseModal}
            hideFooter={true}
            modalSize="modal-xl"
            modalHeight="80vh"
            title="View Document"
            // onSubmit={handleAgreementDocumentUpdate}
            child={
               <div style={{ position: "relative", height: "70vh", overflow: "hidden" }}>
                  {isIframeLoading && (
                     <div
                        style={{
                           position: "absolute",
                           top: "0",
                           left: "0",
                           width: "100%",
                           height: "100%",
                           display: "flex",
                           alignItems: "center",
                           justifyContent: "center",
                           zIndex: 10,
                           backgroundColor: "#fff",
                        }}
                     >
                        <div className="spinner-border text-primary" role="status">
                           <span className="visually-hidden"></span>
                        </div>
                     </div>
                  )}
                  <iframe
                     key={iframeKey}
                     src={getDocumentURL(value)}
                     style={{ width: "100%", height: "100%", border: "none" }}
                     title="View Document"
                     onLoad={() => setIsIframeLoading(false)}
                  ></iframe>
               </div>
            }
         />
         {label && (
            <label className="text-capitalize" htmlFor={id}>
               {label}
               {require && <span className="text-danger">*</span>}
            </label>
         )}
         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <input
               type="file"
               id={id}
               name={name}
               className="form-control h-auto"
               onChange={handleFileChange}
               disabled={disabled}
               multiple={multiple}
               accept=".png,.jpg,.jpeg,.csv,.txt,.pdf"
            />
            {value && (
               <>
                  <Button
                     variant="contained"
                     onClick={() => {
                        setIsIframeLoading(true);
                        setIframeKey((prev) => prev + 1);
                        handleShowImageModal();
                     }}
                  >
                     <BsEyeFill style={{ height: "1.5rem", width: "1.5rem" }} />
                  </Button>

                  <Button variant="contained" onClick={fallbackDownload}>
                     <BsFileEarmarkArrowDown
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </Button>
               </>
            )}
         </Box>
         <div className="text-muted mt-1" style={{ fontSize: "0.75rem" }}>
            Allowed types: PNG, JPG, JPEG, CSV, TXT, PDF. Max size: 10 MB.
         </div>
         {errors && (
            <div className="text-danger mt-1" style={{ fontSize: ".8rem" }}>
               {message}
            </div>
         )}
      </div>
   );
};

export default CustomFileUpload;
